import Vue from 'vue'
import VueRouter from 'vue-router'
import AppPageHome from '@/components/app-page-home'
import AppPageMenu from '@/components/app-page-menu'
import AppPageChapters from '@/components/app-page-chapters'
import AppPageChapter from '@/components/app-page-chapter'
import AppPageStories from '@/components/app-page-stories'
import AppPageStory from '@/components/app-page-story'
import AppPageSimple from '@/components/app-page-simple'
import AppPageAbout from '@/components/app-page-about'
import AppPage404 from '@/components/app-page-404'

import config from '@/config/index.js'
import routesConfig from '@/config/routes.json'

const components = {
    AppPageHome,
    AppPageMenu,
    AppPageChapters,
    AppPageChapter,
    AppPageStories,
    AppPageStory,
    AppPageSimple,
    AppPageAbout,
    AppPage404
}

routesConfig.map((_item) =>
{
    _item.component = components[_item.component]
})

routesConfig.push(
    {
        path: '/',
        name: 'default',
        component: AppPageHome,
        meta: { name: 'default' }
    }
)

routesConfig.push(
    {
        path: '/*',
        name: '404',
        component: AppPage404,
        meta: { lang: 'en', name: '404' }
    }
)

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: routesConfig
})

router.beforeEach((to, from, next) =>
{
    if(to.name === 'default')
    {
        const navigatorLang = navigator.language || navigator.userLanguage

        const navigatorLangMatch = config.langs.all.find((_lang) =>
        {
            return navigatorLang.match(new RegExp(_lang))
        })

        // Navigator lang exist
        if(navigatorLangMatch)
        {
            next({ name: `${navigatorLangMatch}_${config.langs.default.name}` })
        }

        // Navigator lang doesn't exist
        else
        {
            next({ name: `${config.langs.default.lang}_${config.langs.default.name}` })
        }
    }
    else
    {
        next()
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js